import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import Styled from 'styled-components'

import Signup from 'components/Signup'
import Login from 'components/Login'
import Logout from 'components/Logout'

const Container = Styled.div`
  height: 100%;
  background: ${props => props.theme.colors.lightestGray};
`

const Content = Styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`

class Auth extends Component {
  render() {
    const { location } = this.props

    return (
      <TransitionGroup component={Container}>
        <CSSTransition key={location.pathname} timeout={600} classNames="route-fade" appear>
          <Content>
            <Switch location={location}>
              <Route path={`${this.props.match.path}/sign-up`} component={Signup} />
              <Route path={`${this.props.match.path}/login`} component={Login} />
              <Route path={`${this.props.match.path}/logout`} component={Logout} />
            </Switch>
          </Content>
        </CSSTransition>
      </TransitionGroup>
    )
  }
}

export default Auth



// WEBPACK FOOTER //
// ./src/components/Auth/index.js